module.exports = __webpack_public_path__ + "d69924b98acd849cdeba9fbff3f88ea6.woff2";